import { render, staticRenderFns } from "./WizardShell.vue?vue&type=template&id=a60eede2&scoped=true"
import script from "./WizardShell.vue?vue&type=script&lang=js"
export * from "./WizardShell.vue?vue&type=script&lang=js"
import style0 from "./WizardShell.vue?vue&type=style&index=0&id=a60eede2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60eede2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a60eede2')) {
      api.createRecord('a60eede2', component.options)
    } else {
      api.reload('a60eede2', component.options)
    }
    module.hot.accept("./WizardShell.vue?vue&type=template&id=a60eede2&scoped=true", function () {
      api.rerender('a60eede2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/catalog/WizardShell.vue"
export default component.exports